export const FOCUSED_ONBOARDING_PATHS = [
  '/onboarding',
  '/onboarding-knowledge',
  '/onboarding-customize-ai',
  '/phone-numbers',
];

export function isFocusedOnboardingPath(pathname) {
  return FOCUSED_ONBOARDING_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`));
}
